import {
  Armchair,
  BadgeCheck,
  BarChart3,
  BookOpen,
  Boxes,
  Building2,
  Calendar,
  CheckSquare,
  Contact,
  Gift,
  Globe,
  Landmark,
  Layers,
  LayoutDashboard,
  LineChart,
  MapPin,
  Megaphone,
  Package,
  Receipt,
  Scissors,
  ScrollText,
  Settings2,
  Upload,
  UserPlus,
  Users,
  Wallet,
  Zap,
} from 'lucide-react'

/** @type {Record<string, import('lucide-react').LucideIcon>} */
export const NAV_ICONS = {
  'layout-dashboard': LayoutDashboard,
  calendar: Calendar,
  globe: Globe,
  receipt: Receipt,
  contact: Contact,
  users: Users,
  'bar-chart': BarChart3,
  'line-chart': LineChart,
  'user-plus': UserPlus,
  badge: BadgeCheck,
  'check-square': CheckSquare,
  book: BookOpen,
  boxes: Boxes,
  landmark: Landmark,
  building: Building2,
  'map-pin': MapPin,
  'scroll-text': ScrollText,
  layers: Layers,
  scissors: Scissors,
  armchair: Armchair,
  gift: Gift,
  megaphone: Megaphone,
  package: Package,
  settings: Settings2,
  zap: Zap,
  upload: Upload,
  wallet: Wallet,
}

/**
 * @param {string} name
 */
export function getNavIcon(name) {
  return NAV_ICONS[name] ?? LayoutDashboard
}
